import styled from 'styled-components';

export const Plans = styled.div`
  background: white;
  min-height: 100%;
`
